module.exports = __webpack_public_path__ + "static/img/czalo.75229fc1.png";